export default __webpack_public_path__ + "static/media/opensea.2d072db1.gif";